var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "900" } },
        [
          _c(
            "w-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$ct("settings")) + " "),
              _c("w-spacer"),
              _c(
                "w-link",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.close"),
                      expression: "$ct('common.close')",
                    },
                  ],
                  attrs: { white: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "div" } },
            [
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("settings-name"),
                            },
                            model: {
                              value: _vm.settings.Name,
                              callback: function ($$v) {
                                _vm.$set(_vm.settings, "Name", $$v)
                              },
                              expression: "settings.Name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-file-upload", {
                            model: {
                              value: _vm.worksheet,
                              callback: function ($$v) {
                                _vm.worksheet = $$v
                              },
                              expression: "worksheet",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              fancy: "",
                              label: _vm.$ct("row-offset"),
                              decimals: 0,
                              min: 1,
                            },
                            model: {
                              value: _vm.config.HeaderRow,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "HeaderRow", $$v)
                              },
                              expression: "config.HeaderRow",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._t("extra-settings", null, { settings: _vm.settings }),
                ],
                2
              ),
              _c("app-columns-edit", {
                attrs: {
                  "known-headers": _vm.knownHeaders,
                  settings: _vm.config,
                  "allowed-output-headers": _vm.allowedOutputHeaders,
                },
              }),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { icon: "save", disabled: _vm.isSaving },
                  on: {
                    click: function ($event) {
                      return _vm.saveSettings()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }